import React from "react";
import { useFormContext } from "react-hook-form";
import FlightIcon from "../../../../assets/icons/auth-form/flight.png";
import MapIcon from "../../../../assets/icons/auth-form/map.png";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import { EMPTY_STRING } from "../../../../constants";

const options = [
  { title: "2-4 Hours Flight", icon: FlightIcon, id: 1 },
  { title: "4-8 Hours Flight", icon: FlightIcon, id: 2 },
  { title: "8-16 Hours Flight", icon: FlightIcon, id: 3 },
  { title: "Same Country", icon: MapIcon, id: 4 },
];
const LovedOnesDistancePreference = () => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <div className="question-heading">
        Proximity to loved ones, how important is it for you to be near in terms
        of travel distance?
      </div>
        {errors.travelDistanceLovedOnes && (
          <div className="error">
            {errors.travelDistanceLovedOnes.message}
          </div>
        )}
      <div className="form-fields">
        {options.map((option, index) => (
          <SurveyFormField
            name="travelDistanceLovedOnes"
            key={index}
            variant="radio"
            label={option.title}
            value={option.id}
            endAdornment={
              option.icon && (
                <div className="position-absolute marks-adornment">
                  <img src={option.icon} alt={EMPTY_STRING} />
                </div>
              )
            }
          />
        ))}
      </div>
    </div>
  );
};

export default LovedOnesDistancePreference;
